var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    fill: "none",
    viewBox: "0 0 166 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#adafae",
    fillRule: "evenodd",
    d: "M59 18c0-2.485 2.015-4.5 4.5-4.5H104V37c0 4.694 3.806 8.5 8.5 8.5H142V129c0 2.485-2.015 4.5-4.5 4.5h-74c-2.485 0-4.5-2.015-4.5-4.5V18zm65.259 9.425L117 21.175V32.5h13.407l-6.043-4.986-.053-.044-.052-.044zM63.5.5C53.835.5 46 8.335 46 18v3.5H28.5C18.835 21.5 11 29.335 11 39v111c0 9.665 7.835 17.5 17.5 17.5h74c9.665 0 17.5-7.835 17.5-17.5v-3.5h17.5c9.665 0 17.5-7.835 17.5-17.5V35.936l-2.364-1.95-19.947-16.456-17.948-15.456L112.913.5H63.5zm43.5 146H63.5c-9.665 0-17.5-7.835-17.5-17.5V34.5H28.5c-2.485 0-4.5 2.015-4.5 4.5v111c0 2.485 2.015 4.5 4.5 4.5h74c2.485 0 4.5-2.015 4.5-4.5v-3.5z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.92d859d6.svg";
export { ForwardRef as ReactComponent };